import { z } from 'zod';
export const DeviceKind = z.enum(['desktop', 'mobile', 'tablet', 'bot', 'unknown']);
//# sourceMappingURL=device-kind.js.map